export default "__VITE_ASSET__4jZg94jI__"